module.exports = __webpack_public_path__ + "img/Loader.6101c007.gif";